import React, { useState } from 'react';
import { PhoneScamCard } from './CardClickable';
import { PhoneScamModal } from './Modal';
import { PhoneScamCardDefault } from './CardDefault';

export function PhoneScamNotify({
  handleCardClick,
  handleMainButtonModalClick,
  handleCloseModalClick
}: Readonly<{
  handleCardClick: () => void;
  handleMainButtonModalClick: () => void;
  handleCloseModalClick: () => void;
}>): JSX.Element {
  const [showScamAlertModal, setShowScamAlertModal] = useState(false);

  return (
    <>
      <PhoneScamCard
        handleClick={() => {
          setShowScamAlertModal(true);
          handleCardClick();
        }}
      />

      {showScamAlertModal && (
        <PhoneScamModal
          modalOpen={showScamAlertModal}
          handleState={() => {
            setShowScamAlertModal(false);
          }}
          handleClose={handleCloseModalClick}
          handleMainClick={handleMainButtonModalClick}
        />
      )}
    </>
  );
}

export function PhoneScamNotifyDefault(): JSX.Element {
  return <PhoneScamCardDefault />;
}
